import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Settings, Clock, CalendarX, CheckCircle } from 'lucide-react';
import { WeeklyHoursEditor } from './WeeklyHoursEditor';
import { AvailabilityOverridesList } from './AvailabilityOverridesList';

export function AvailabilityTab({ sessionToken }) {
  const [lastUpdated, setLastUpdated] = useState(null);

  const handleUpdate = () => {
    setLastUpdated(new Date());
  };

  return (
    <div className="space-y-6" data-testid="availability-tab">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
            <Settings className="w-6 h-6" />
            Availability Settings
          </h2>
          <p className="text-gray-500 mt-1">
            Manage business hours and block dates for consultation bookings
          </p>
        </div>
        {lastUpdated && (
          <Badge variant="outline" className="flex items-center gap-1">
            <CheckCircle className="w-3 h-3 text-green-500" />
            Last saved: {lastUpdated.toLocaleTimeString()}
          </Badge>
        )}
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                <Clock className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Business Hours</p>
                <p className="font-semibold">Mon-Fri, 9AM-5PM ET</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                <CheckCircle className="w-5 h-5 text-green-600" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Slot Duration</p>
                <p className="font-semibold">30 minutes</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                <CalendarX className="w-5 h-5 text-amber-600" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Min. Notice</p>
                <p className="font-semibold">3 hours</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Weekly Hours Editor */}
      <WeeklyHoursEditor 
        sessionToken={sessionToken} 
        onUpdate={handleUpdate}
      />

      {/* Blocked Dates */}
      <AvailabilityOverridesList 
        sessionToken={sessionToken}
        onUpdate={handleUpdate}
      />
    </div>
  );
}

export default AvailabilityTab;
